export default __webpack_public_path__ + "static/media/logo-white.c57c8abc.svg";